import { createAsyncThunk } from '@reduxjs/toolkit';
import { _reportUrls } from '@custom/Utils/constants/apiUrls';

const previewReportDownloadApi = createAsyncThunk(
  'previewReportDownloadApi',
  async (reportId: string) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const url = `${_reportUrls.previewReportDownload}`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ reportId })
      });

      if (!response.ok) {
        throw new Error('Failed to fetch report details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

export default previewReportDownloadApi;
